module.exports = __webpack_public_path__ + "static/media/2.60a55927.png";